import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import {
  FaUser,
  FaUsers,
  FaUserShield,
  FaFileExcel,
  FaClipboardList,
  FaSignOutAlt,
} from 'react-icons/fa';

import './style.css';
import host, { getLink } from '../../services/host';
import { getStorage, clearStorage, hasStorage } from '../../utils/storage';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
      redirectLogin: false,
    };

    this.menu = this.menu.bind(this);
    this.onSelectMenu = this.onSelectMenu.bind(this);
    this.sair = this.sair.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.dropdownRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleClickOutside(event) {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ menuActive: false });
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape' && this.state.menuActive) {
      this.setState({ menuActive: false });
    }
  }

  menu() {
    this.setState({ menuActive: !this.state.menuActive });
  }

  onSelectMenu() {
    this.setState({ menuActive: false });
  }

  sair(e) {
    e.preventDefault();

    // Remove dados do login
    clearStorage();

    // Vai para o login
    this.setState({ redirectLogin: true });
  }

  renderAdminDropdown() {
    return (
      <div className={`dropdown ${this.state.menuActive ? 'active' : ''}`}>
        <Link to={getLink('/dashboard')} onClick={this.onSelectMenu}>
          <FaUsers /> Aplicadores
        </Link>
        <Link to={getLink('/list-administradores')} onClick={this.onSelectMenu}>
          <FaUserShield /> Administradores
        </Link>
        <a
          href={`${host}/export-all-xls?token=${getStorage('token')}`}
          target="_blank"
          onClick={this.onSelectMenu}
          rel="noreferrer"
        >
          <FaFileExcel /> Gerar planilha completa
        </a>
        <a
          href={`${host}/export-xls?token=${getStorage('token')}`}
          target="_blank"
          onClick={this.onSelectMenu}
          rel="noreferrer"
        >
          <FaClipboardList /> Gerar planilha de testes
        </a>
        <button type="button" onClick={this.sair}>
          <FaSignOutAlt /> Sair
        </button>
      </div>
    );
  }

  renderInstitucionalDropdown() {
    return (
      <div className={`dropdown ${this.state.menuActive ? 'active' : ''}`}>
        <Link to={getLink('/dashboard')} onClick={this.onSelectMenu}>
          <FaUsers /> Aplicadores
        </Link>
        <a
          href={`${host}/export-all-xls?token=${getStorage('token')}`}
          target="_blank"
          onClick={this.onSelectMenu}
          rel="noreferrer"
        >
          <FaFileExcel /> Gerar planilha completa
        </a>
        <a
          href={`${host}/export-xls?token=${getStorage('token')}`}
          target="_blank"
          onClick={this.onSelectMenu}
          rel="noreferrer"
        >
          <FaClipboardList /> Gerar planilha de testes
        </a>
        <button type="button" onClick={this.sair}>
          <FaSignOutAlt /> Sair
        </button>
      </div>
    );
  }

  renderPesquisadorDropdown() {
    return (
      <div className={`dropdown ${this.state.menuActive ? 'active' : ''}`}>
        <Link to={getLink('/dashboard')} onClick={this.onSelectMenu}>
          <FaUser /> Pacientes
        </Link>
        <a
          href={`${host}/export-all/pesquisador/${getStorage('id_pesquisador')}?token=${getStorage('token')}`}
          target="_blank"
          onClick={this.onSelectMenu}
          rel="noreferrer"
        >
          <FaFileExcel /> Gerar planilha completa
        </a>
        <a
          href={`${host}/export/pesquisador/${getStorage('id_pesquisador')}?token=${getStorage('token')}`}
          target="_blank"
          onClick={this.onSelectMenu}
          rel="noreferrer"
        >
          <FaClipboardList /> Gerar planilha de testes
        </a>
        <button type="button" onClick={this.sair}>
          <FaSignOutAlt /> Sair
        </button>
      </div>
    );
  }

  renderDropdownMenu() {
    const userType = getStorage('tipo');
    const isAdmin = userType === 1 || userType === '1';
    const isMemnon = hasStorage('isMemnon');

    if (isAdmin && !isMemnon) {
      return this.renderAdminDropdown();
    } else if (isMemnon) {
      return this.renderInstitucionalDropdown();
    } else {
      return this.renderPesquisadorDropdown();
    }
  }

  render() {
    return (
      <header id="header">
        <div className="top-bar">
          <div className="container">
            <div className="logo">
              <div className="logo-text">Stroop App</div>
              <div className="logo-version">
                {process.env.REACT_APP_VERSION}
              </div>
            </div>

            <div className="user-menu-container" ref={this.dropdownRef}>
              <div className="btn-user" onClick={this.menu}>
                <FaUser />
              </div>
              {this.renderDropdownMenu()}
            </div>
          </div>
        </div>

        <div className="heightHeader"></div>

        {this.state.redirectLogin && (
          <Redirect to={`${process.env.PUBLIC_URL}/`} />
        )}
      </header>
    );
  }
}

export default Header;
